import {BASE_URL} from "../../../config"


export default {
  loginEndpoint: `${BASE_URL}/login`,
  // registerEndpoint: "/jwt/register",
  // refreshEndpoint: "/jwt/refresh-token",
  // logoutEndpoint: "/jwt/logout",

  // ! batch-child-controller LOTE
  batchChildEndpint: `${BASE_URL}/api/batchChild`,
  batchEndpint: `${BASE_URL}/api/batch`,
  employeeEndpoint: `${BASE_URL}/api/employee`,
  catalogEndpoint: `${BASE_URL}/api/employee`,
  apiEndpoint: `${BASE_URL}/api`,
  // ! USER
  userEndpoint: `${BASE_URL}/api/user`,
  getPasswordStatus: `${BASE_URL}/api/user/getPasswordStatus`,

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken"
}
